import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import { LoginGate } from '@/components/LoginGate'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { routes } from '@/routes'

const router = createBrowserRouter(routes)

export default function App() {
  return (
    <TooltipProvider delayDuration={200} skipDelayDuration={300}>
      {/*
        🔴 로그인하지 않으면 화면 자체가 그려지지 않습니다.
           실제 차단은 서버(`voxctx/auth.py`)가 합니다 — 이 껍데기는 상태를
           보여 줄 뿐이며, 이것만으로 안전하다고 여기지 않습니다.
      */}
      <LoginGate>
        <RouterProvider router={router} />
      </LoginGate>
      <Toaster />
    </TooltipProvider>
  )
}
